import { Badge } from '../ui/badge';
import { Lightbulb, Calendar, Users } from 'lucide-react';
import { type Campaign } from './types';
import { formatDate } from './utils';

interface CampaignTooltipContentProps {
    campaign: Campaign;
}

export function CampaignTooltipContent({ campaign }: CampaignTooltipContentProps) {
    return (
        <div className="p-4 max-w-80 space-y-3">
            <div className="border-b pb-2">
  <h4 className="font-medium">{campaign.name}</h4>
     <p className="text-sm text-gray-600">{campaign.businessUnit} {campaign.category}</p>
            </div>

    <div className="space-y-2">
   <div className="flex items-center gap-2">
        <Badge
         variant="secondary"
         className={`text-xs ${campaign.status === 'active' ? 'bg-green-100 text-green-800' :
        campaign.status === 'upcoming' ? 'bg-blue-100 text-blue-800' :
            'bg-gray-100 text-gray-800'
       }`}
 >
         {campaign.status === 'active' ? 'Active' :
     campaign.status === 'upcoming' ? 'Upcoming' : 'Completed'}
      </Badge>
      <span className="text-sm text-gray-600">{campaign.campaignType}</span>
   </div>

      {campaign.concept && (
        <div className="flex items-center gap-1 text-sm">
    <Lightbulb className="w-3 h-3 text-purple-600" />
         <span className="text-purple-700 font-medium">{campaign.concept}</span>
   </div>
         )}

       <div className="flex items-center gap-1 text-sm text-gray-600">
       <Calendar className="w-3 h-3" />
          <span>{formatDate(campaign.startDate)} - {formatDate(campaign.endDate)}</span>
            </div>

     <div className="flex items-center gap-1 text-sm text-gray-600">
   <Users className="w-3 h-3" />
    <span>{campaign.targetProfile}</span>
   </div>

      {campaign.platforms && campaign.platforms.length > 0 && (
    <div className="text-sm">
    <span className="text-gray-600">Platforms: </span>
  <span>{campaign.platforms.join(', ')}</span>
    </div>
      )}

     {campaign.products && campaign.products.length > 0 && (
        <div className="text-sm">
    <span className="text-gray-600">Products: </span>
     <span>{campaign.products.slice(0, 2).join(', ')}</span>
    {campaign.products.length > 2 && <span className="text-gray-500"> +{campaign.products.length - 2} more</span>}
     </div>
      )}
  </div>
        </div>
    );
}
